/**
 * Predicate fn that checks if browser is IE11 or below using useragent.
 * See for more info https://stackoverflow.com/a/22551342/2167740
 *
 * @returns Boolean
 */
export default () => Boolean(window?.navigator?.userAgent.match(/MSIE|Trident/))
